module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate2_m_en.05b8095f0ea0ab3cf481cb8a25a61345.png";